import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { TipoFlota, TipoFlotaPagingRes } from '@/shared/interfaces/erp/mantenimiento-operaciones';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchTipoFlota = (params?: GetTipoFlotaParams) => {
  return useQuery({
    queryKey: ['adminTipoFlota', ...Object.values(params || {})],
    queryFn: async () => {
      return getTiposFlota(params);
    },
  });
};

export const useGetTipoFlota = (id: string) => {
  return useQuery({
    queryKey: ['adminTipoFlota', id],
    queryFn: async () => {
      return getTipoFlota(id);
    },
  });
};

export const useCreateTipoFlota = (
  navigate: NavigateFunction,
  returnUrl: string,
  enableNavigation = true
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTipoFlota,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminTipoFlota'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

export const useUpdateTipoFlota = (
  navigate: NavigateFunction,
  returnUrl: string,
  noState?: boolean,
  enableNavigation?: boolean
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTipoFlota,
    onSuccess: () => {
      noState && queryClient.invalidateQueries({ queryKey: ['adminTipoFlota'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
      onError: error => {
        handleAxiosError(error);
      },
  });
};

///* axios
export type GetTipoFlotaParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
  codigo?: string;
};
export type CreateTipoFlotaParams = Omit<TipoFlota, 'id_tipo_flota'>;
export type UpdateTipoFlotaParams = {
  id: string;
  data: CreateTipoFlotaParams;
};

export const getTiposFlota = async (params?: GetTipoFlotaParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<TipoFlotaPagingRes>(
    `${urlBackend}api/tipos-flota/?${queryParams}`,
    true
  );
};

export const getTipoFlota = async (id: string) => {
  try{
    return await get<TipoFlota>(`${urlBackend}api/tipos-flota/${id}`, true);
  }
  catch(error){
    return handleAxiosError(error);
  }
};

export const createTipoFlota = async (data: CreateTipoFlotaParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<TipoFlota>(
    `${urlBackend}api/v1/tipos-flota/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};

export const updateTipoFlota = async ({ id, data }: UpdateTipoFlotaParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<TipoFlota>(
    `${urlBackend}api/v1/tipos-flota/${id}/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};
